import styled from "styled-components";
import {Tabs, Card, Button, Row} from "antd";

const {TabPane} = Tabs;

export const ReportsContainer = styled.div`
    width: 100%;
    background: white;
    padding: 24px;
    border-radius: 8px;
    margin-bottom: 24px;
    border: 1px solid #f0f0f0;
    position: relative;
    overflow: hidden;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    margin-top: 24px;

    @media screen and (max-width: 768px) {
        padding: 16px;
        margin-top: 16px;
        margin-bottom: 16px;
        border-radius: 6px;
    }

    @media screen and (max-width: 480px) {
        padding: 12px;
        margin-top: 12px;
        margin-bottom: 12px;
        border-radius: 4px;
    }
`;

export const FilterSection = styled.div``;

export const DownloadButton = styled(Button)`
    height: 40px;
    border-radius: 8px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #aef001;
    border-color: #aef001;
    color: #000;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);

    &:hover,
    &:focus {
        background-color: #9dd600;
        border-color: #9dd600;
        color: #000;
        transform: translateY(-2px);
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    }

    @media screen and (max-width: 768px) {
        height: 36px;
        font-size: 14px;
        gap: 6px;
    }

    @media screen and (max-width: 480px) {
        height: 32px;
        font-size: 13px;
        gap: 4px;
        padding: 0 12px;
    }
`;

export const EmptyState = styled.div`
    padding: 40px 20px;
    text-align: center;
    color: #666;

    .anticon {
        font-size: 48px;
        margin-bottom: 16px;
        color: #d9d9d9;
    }

    p {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
    }
`;

export const StyledTabs = styled(Tabs)`
    .ant-tabs-tab {
        padding: 12px 16px;
        font-weight: 500;

        &.ant-tabs-tab-active {
            .ant-tabs-tab-btn {
                color: #000000;
                font-weight: 600;
            }
        }
    }

    .ant-tabs-ink-bar {
        background: #000000;
    }

    .ant-tabs-content-holder {
        padding-top: 24px;
    }

    @media screen and (max-width: 768px) {
        .ant-tabs-tab {
            padding: 10px 12px;
            font-size: 14px;
        }

        .ant-tabs-content-holder {
            padding-top: 16px;
        }
    }

    @media screen and (max-width: 480px) {
        .ant-tabs-tab {
            padding: 8px 10px;
            font-size: 13px;
        }

        .ant-tabs-content-holder {
            padding-top: 12px;
        }
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    max-width: 180px;

    @media screen and (max-width: 768px) {
        max-width: 100%;
        justify-content: center;
        margin-top: 16px;
    }

    @media screen and (max-width: 480px) {
        margin-top: 12px;
    }
`;

export const FilterRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0px;
        align-items: stretch;
    }
`;

export const FiltersContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    gap: 16px;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
    justify-content: flex-end;
`;

export const FilterContainer = styled.div`
    flex: 1;
    min-width: 280px;
    max-width: 400px;
    margin-right: -100px;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
        width: 100%;
        min-width: unset;
        max-width: unset;
        flex: unset;
        margin-right: 0;
    }
`;

export const ReportsFilterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 16px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;

export const SubCompanyFilterWrapper = styled.div`
    margin-left: ${props => (props.isExpanded ? "100px" : "0px")};

    .ant-select {
        margin-bottom: 0 !important;
    }

    @media (max-width: 768px) {
        margin-left: 0;
    }
`;

export const DatePickerWrapper = styled.div`
    .ant-select {
        margin-bottom: 0 !important;
    }

    .ant-picker {
        margin-bottom: 0 !important;
    }

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;
